"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    ExpandableInput: ()=>ExpandableInput
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_clsx_namespaceObject = require("clsx");
var external_clsx_default = /*#__PURE__*/ __webpack_require__.n(external_clsx_namespaceObject);
const react_namespaceObject = require("motion/react");
const external_react_namespaceObject = require("react");
const external_styled_components_namespaceObject = require("styled-components");
var external_styled_components_default = /*#__PURE__*/ __webpack_require__.n(external_styled_components_namespaceObject);
const RealtimeIcon_js_namespaceObject = require("../../svgs/RealtimeIcon.js");
const StyledDiv = /*#__PURE__*/ external_styled_components_default().div.withConfig({
    displayName: "ExpandableInput__StyledDiv"
})([
    "#realtime-voice-button{svg{display:block !important;}}"
]);
function ExpandableInput({ setiValues = {
    isIconVoiceButton: false,
    isIconOnlyButton: false
}, placeholder = 'Ask Penny a question', className, id, value, onChange, maxLineHeight = 3, disabled = false, voiceIconClassName, submitIconClassName, variant = 'glow', voiceIcon, submitIcon, onSubmitClickHandler, onVoiceClickHandler, onHeightChange }) {
    const [inputValue, setInputValue] = (0, external_react_namespaceObject.useState)(value || '');
    const textareaRef = (0, external_react_namespaceObject.useRef)(null);
    const [isMultiLine, setIsMultiLine] = (0, external_react_namespaceObject.useState)(false);
    const [textareaHeight, setTextareaHeight] = (0, external_react_namespaceObject.useState)(32);
    const [isHovered, setIsHovered] = (0, external_react_namespaceObject.useState)(false);
    const adjustHeight = ()=>{
        const textarea = textareaRef.current;
        if (textarea) {
            textarea.style.height = 'auto';
            const scrollHeight = textarea.scrollHeight;
            const lineHeight = parseInt(window.getComputedStyle(textarea).lineHeight);
            const maxHeight = lineHeight * maxLineHeight;
            const hasMultipleLines = scrollHeight - 20 > lineHeight;
            setIsMultiLine(hasMultipleLines);
            let finalHeight;
            if (scrollHeight > maxHeight) {
                finalHeight = maxHeight;
                textarea.style.height = `${maxHeight}px`;
                textarea.style.overflowY = 'auto';
            } else {
                finalHeight = scrollHeight;
                textarea.style.height = `${scrollHeight}px`;
                textarea.style.overflowY = 'hidden';
            }
            onHeightChange(finalHeight);
            setTextareaHeight(finalHeight);
        }
    };
    (0, external_react_namespaceObject.useEffect)(()=>{
        adjustHeight();
    }, [
        inputValue
    ]);
    (0, external_react_namespaceObject.useEffect)(()=>{
        const styleId = 'subtle-gradient-style';
        if (!document.getElementById(styleId)) {
            const style = document.createElement('style');
            style.id = styleId;
            style.textContent = `
        .subtle-glow:hover:not(:disabled),
        .subtle-glow:focus:not(:disabled) {
          outline: none;
          border: 1px solid transparent;
          background-image: linear-gradient(white, white), linear-gradient(to right, #7700BB, #5C18C7, #0068EF);
          background-origin: border-box;
          background-clip: padding-box, border-box;
          box-shadow: 0 0 4px rgba(119, 0, 187, 0.2);
        }

         .no-glow:hover:not(:disabled),
      .no-glow:focus:not(:disabled) {
        border-color: #496785 !important;
        transition: border-color 0.2s ease;
      }


      `;
            document.head.appendChild(style);
        }
    }, []);
    (0, external_react_namespaceObject.useEffect)(()=>{
        if (textareaRef.current) textareaRef.current.focus();
    }, [
        disabled,
        textareaRef
    ]);
    const setFocusTextarea = ()=>{
        if (textareaRef.current) textareaRef.current.focus();
    };
    function handleChange(e) {
        const newValue = e.target.value;
        setInputValue(newValue);
        if (onChange) onChange(newValue);
    }
    function handleSubmit() {
        if (!onSubmitClickHandler || !inputValue.trim()) return;
        onSubmitClickHandler(inputValue);
        setInputValue('');
        setFocusTextarea();
    }
    function handleKeyDown(e) {
        if ('Enter' === e.key && !e.shiftKey) {
            e.preventDefault();
            handleSubmit();
        }
    }
    const defaultButton = !setiValues.isIconOnlyButton && !setiValues.isIconVoiceButton;
    const renderVoiceButton = ()=>{
        if (defaultButton) return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
            className: "relative flex h-[32px] max-h-[32px] w-[32px] max-w-[32px] -translate-x-2 translate-y-1 items-center justify-end rounded-full",
            children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(react_namespaceObject.AnimatePresence, {
                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(react_namespaceObject.motion.button, {
                    type: "button",
                    initial: {
                        opacity: 0,
                        scale: 0.8
                    },
                    animate: {
                        opacity: 1,
                        scale: 1
                    },
                    exit: {
                        opacity: 0,
                        scale: 0.8
                    },
                    transition: {
                        duration: 0.075,
                        ease: 'easeOut'
                    },
                    "aria-label": "voice input",
                    className: `absolute inset-0 ${voiceIconClassName}`,
                    style: {
                        borderRadius: '50%'
                    },
                    onClick: onVoiceClickHandler,
                    children: voiceIcon
                }, "voice-button")
            })
        });
        if (setiValues.isIconOnlyButton) return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(RealtimeIcon_js_namespaceObject.RealtimeIconButton, {
            onClick: onVoiceClickHandler
        }, "voice-button");
        if (setiValues.isIconVoiceButton) return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(RealtimeIcon_js_namespaceObject.RealtimeVoiceButton, {
            onClick: onVoiceClickHandler
        }, "voice-button");
    };
    const renderSubmitButton = ()=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
            className: "relative flex h-[32px] max-h-[32px] w-[32px] max-w-[32px] -translate-x-2 translate-y-1 items-center justify-end rounded-full",
            children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(react_namespaceObject.AnimatePresence, {
                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(react_namespaceObject.motion.button, {
                    type: "button",
                    initial: {
                        opacity: 0,
                        scale: 0.8
                    },
                    animate: {
                        opacity: 1,
                        scale: 1
                    },
                    exit: {
                        opacity: 0,
                        scale: 0.8
                    },
                    transition: {
                        duration: 0.075,
                        ease: 'easeOut'
                    },
                    "aria-label": "send message",
                    className: `absolute inset-0 ${submitIconClassName}`,
                    onClick: handleSubmit,
                    style: {
                        borderRadius: '50%'
                    },
                    children: submitIcon
                }, "send-button")
            })
        });
    const renderButtons = ()=>{
        if (submitIcon && voiceIcon) return 0 === inputValue.length ? renderVoiceButton() : renderSubmitButton();
        if (submitIcon && !voiceIcon) return renderSubmitButton();
        return null;
    };
    function resolvedBoderColor() {
        if ('default' === variant && isHovered) return '#496785';
        if ('glow' === variant && isHovered) return;
        return '#c0cad5';
    }
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("button", {
        className: external_clsx_default()('border- relative border bg-white transition-all', isMultiLine ? 'rounded-xl' : 'rounded-full', {
            'subtle-glow focus:outline-none focus:ring-0': 'glow' === variant
        }, {
            'no-glow focus:outline-none focus:ring-0': 'default' === variant
        }),
        style: {
            width: '100%',
            borderColor: resolvedBoderColor()
        },
        type: 'button',
        "aria-labelledby": "container-wrapper-expandable-text",
        onMouseEnter: function() {
            setIsHovered(true);
        },
        onMouseLeave: function() {
            setIsHovered(false);
        },
        children: [
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'stretch'
                },
                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(StyledDiv, {
                    style: {
                        display: 'flex',
                        alignItems: 'center',
                        flex: '90%'
                    },
                    children: [
                        /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("textarea", {
                            ref: textareaRef,
                            id: id,
                            value: inputValue,
                            "aria-label": "Message input",
                            onChange: handleChange,
                            onKeyDown: handleKeyDown,
                            placeholder: placeholder,
                            disabled: disabled,
                            rows: 1,
                            className: external_clsx_default()('border-0 bg-transparent focus:outline-none focus:ring-0', disabled && 'cursor-not-allowed bg-slate-100', className),
                            style: {
                                resize: 'none',
                                padding: '8px 16px 0',
                                width: '100%',
                                color: '#001833'
                            }
                        }),
                        renderButtons()
                    ]
                })
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                style: {
                    height: '8px'
                }
            })
        ]
    });
}
exports.ExpandableInput = __webpack_exports__.ExpandableInput;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "ExpandableInput"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
